
import {spApi} from './sp'

export const cancelSubscriptionApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    
    cancelSubscription: builder.mutation({
     
      query: ({payload}) => ({
        url: '/CancelSubscription',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Subscription'],
    }),

  }),
  overrideExisting: false,
})

export const { useCancelSubscriptionMutation } = cancelSubscriptionApi